import React, {useEffect, useState} from 'react';

// custom components
import { Text } from '../atoms';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

const TableNumber = (props) => {

    useEffect(() => {

    }, []);

    const [STATE, SETSTATE] = useState(false)

    return (
        <>
            <p>{props.title}</p>
            <Text.Text>{props.description}</Text.Text>
        </>
    );
};

export default TableNumber;